const state = {
    token: null,
    userInfo: null,
    userMenus: [],
    noticeId: null
};

const mutations = {
    SET_USERINFO(state, userInfo) {
        state.userInfo = userInfo || null;
    },
    SET_TOKEN(state, token) {
        state.token = token || null;
    },
    SET_USEREMENUS(state, userMenus) {
        state.userMenus = userMenus || [];
    },
    SET_NOTICEID(state, noticeId) {
        state.noticeId = noticeId || null;
    }
};

const actions = {
    setToken({ commit }, payload) {
        commit("SET_TOKEN", payload);
    },
    setUserInfo({ commit }, payload) {
        commit("SET_USERINFO", payload);
    },
    setUserMenus({ commit }, payload) {
        commit("SET_USEREMENUS", payload);
    },
    setNoticeId({ commit }, payload) {
        commit("SET_NOTICEID", payload);
    },
    logout({ commit }) {
        // 清空用户信息
        commit("SET_USERINFO", null);
        commit("SET_TOKEN", null);
        commit("SET_USEREMENUS", []);
        commit("SET_NOTICEID", null);
    }
};

const getters = {
    getUserInfo(state) {
        return state.userInfo;
    },
    getToken(state) {
        return state.token;
    },
    getUserMenus(state) {
        return state.userMenus;
    },
    getNoticeId(state) {
        return state.noticeId;
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};
